<template>
    <div class="vframe">
        <iframe id="videoPreIfm" class="video-preview-iframe" :src="src" frameborder=0 scrolling=0 width="100%" height="100%" allow="fullscreen"></iframe>
    </div>
</template>
<script>
export default {
    props: {
        src: String
    },
    methods:{
        previewBack(startTime, endTime) {

        },
    }
}
</script>
<style lang="scss">
.vframe {
    width: 100%;
    height: 100%;
    .video-preview-iframe {
        width: 100% !important;
        height: 100% !important;
    }
}
</style>